import { render, staticRenderFns } from "./Cotizacion.vue?vue&type=template&id=84d4c3a4&scoped=true"
import script from "./Cotizacion.vue?vue&type=script&lang=js"
export * from "./Cotizacion.vue?vue&type=script&lang=js"
import style0 from "./Cotizacion.vue?vue&type=style&index=0&id=84d4c3a4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d4c3a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84d4c3a4')) {
      api.createRecord('84d4c3a4', component.options)
    } else {
      api.reload('84d4c3a4', component.options)
    }
    module.hot.accept("./Cotizacion.vue?vue&type=template&id=84d4c3a4&scoped=true", function () {
      api.rerender('84d4c3a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/infoBase/Cotizacion.vue"
export default component.exports